module.exports = __webpack_public_path__ + "media/kingsoft.e202205f.mp4";